import baseUrl from "../config/baseUrl";

const deleteEmailTemplateTableRecord = async ({ token, id }) => {
  try {
    const response = await fetch(`${baseUrl}/api/delete-email-template-table-data?id=${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default deleteEmailTemplateTableRecord;
